import SysColumn from "app/class/sys-column";
import { AttachmentPanel } from "modules/record/shared/attachments/AttachmentPanel";
import { BaseField } from "./BaseField";
import { FieldRuntimeProps } from "../../types/record-producer-types";
import { useRecordProducer } from "../RecordProducerContext";

type Props = {
    column: SysColumn;
    runtimeProps?: FieldRuntimeProps;
};

export const AttachmentFieldComponent = ({ column, runtimeProps }: Props) => {
    const recordProducer = useRecordProducer();

    return (
        <BaseField
            as="group"
            column={column}
            hidden={runtimeProps?.hidden}
            required={runtimeProps?.required}
        >
            <AttachmentPanel
                tableName={recordProducer.table.name}
                recordId={recordProducer.recordId}
                draftToken={recordProducer.attachmentDraftToken}
                columnName={column.name}
                compact
                disabled={runtimeProps?.readonly}
                variant="field"
            />
        </BaseField>
    );
};
